enum LogoutDialogFields {
	PROVIDER = 'provider',
}

export default LogoutDialogFields;